export default __webpack_public_path__ + "static/Crystal-c4ae19bddaa5b9128e6a27aa6ef8883b.png";